// Vistas e modelos do desenho da face (modo Face do plano de tratamento). Coordenadas das marcações
// são normalizadas (0–1) no quadro do desenho, que tem a mesma proporção em todas as vistas e modelos.

/** Ordem das setas: o lado direito do paciente aparece à esquerda de quem olha a frente. */
export const VISTAS_DA_FACE = ["PERFIL_DIREITO", "FRENTE", "PERFIL_ESQUERDO"] as const;
export type VistaDaFace = (typeof VISTAS_DA_FACE)[number];

export const ROTULO_DA_VISTA: Record<VistaDaFace, string> = {
  PERFIL_DIREITO: "Perfil direito",
  FRENTE: "Frente",
  PERFIL_ESQUERDO: "Perfil esquerdo",
};

export const MODELOS_DA_FACE = ["FEMININO", "MASCULINO"] as const;
export type ModeloDaFace = (typeof MODELOS_DA_FACE)[number];

export const ROTULO_DO_MODELO: Record<ModeloDaFace, string> = { FEMININO: "Feminino", MASCULINO: "Masculino" };

/** Quadro do desenho (px) — largura/altura; as medidas de tamanho são frações da largura. */
export const QUADRO_DA_FACE = { largura: 520, altura: 760 } as const;

/** Sobe quando o desenho mudar a ponto de deslocar marcações antigas. */
export const VERSAO_DO_DESENHO = 1;

export function vistaEspelhada(vista: VistaDaFace): VistaDaFace {
  if (vista === "PERFIL_DIREITO") return "PERFIL_ESQUERDO";
  if (vista === "PERFIL_ESQUERDO") return "PERFIL_DIREITO";
  return "FRENTE";
}
